import { takeLatest } from 'redux-saga/effects'
import * as types from '../redux/types'
import { getDispensaryDetailsSaga, getDoctorListSaga, getStaffListSaga } from './Sagas'

export const portalSagas = [
	takeLatest(types.GET_DISPENSARY_DETAILS_REQUEST, getDispensaryDetailsSaga),
	takeLatest(types.GET_DOCTOR_LIST_REQUEST, getDoctorListSaga),
	takeLatest(types.GET_STAFF_REQUEST, getStaffListSaga)
]
